<template>
	<div class="homePage">
		<el-carousel
			class="homePageCarousel"
			height="100%"
			trigger="click"
			:loop="true"
			direction="vertical"
			:autoplay="true"
			ref="carousel"
			@mousewheel.native="rollScroll"
		>
			<el-carousel-item>
				<img class="img" src="@/assets/home1.jpg" alt="" />
			</el-carousel-item>
			<el-carousel-item>
				<img class="img" src="@/assets/vswiper2.png" alt="" />
			</el-carousel-item>
			<el-carousel-item>
				<SlidePage3 />
			</el-carousel-item>
			<el-carousel-item>
				<SlidePage4 />
			</el-carousel-item>
			<el-carousel-item>
				<img class="img" src="@/assets/vswiper5.png" alt="" />
			</el-carousel-item>
			<el-carousel-item>
				<img class="img" src="@/assets/vswiper6.png" alt="" />
			</el-carousel-item>
		</el-carousel>
		<Footer />
	</div>
</template>

<script>
import SlidePage3 from '../components/SlidePage3.vue'
import SlidePage4 from '../components/SlidePage4.vue'
import Footer from './footer.vue'
export default {
	components: {
		SlidePage3,
		SlidePage4,
		Footer,
	},
	data() {
		return {
			scrollBox: {
				time: null,
			},
		}
	},
	computed: {
		// swiper() {
		// 	return this.$refs.mySwiper.swiper
		// },
	},
	mounted() {},
	methods: {
		rollScroll(event) {
			// console.log(event,'----------------')
			let _that = this
			let scrollVal = event.wheelDelta || event.detail
			if (_that.scrollBox.time) {
				clearTimeout(_that.scrollBox.time)
			}
			_that.scrollBox.time = setTimeout(() => {
				scrollVal > 0 ? _that.$refs.carousel.prev() : _that.$refs.carousel.next()
			}, 300)
		},
	},
}
</script>
<style lang="scss" scoped>
.homePage {
	width: 100%;
	height: 100%;
	.homePageCarousel {
		height: 100%;
		::v-deep .el-carousel__indicators--vertical {
			left: 10px;
		}
		::v-deep .el-carousel__indicator--vertical .el-carousel__button {
			width: 14px;
			height: 14px;
			opacity: 1;
			border-radius: 50%;
		}
		::v-deep .el-carousel__indicator.is-active button {
			background: #8cff94;
		}
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
}
</style>
